import { Product } from '../../../models/piramide/Product';

export class Disco extends Product {
  $caracteristicas: {
    TBW: number;
    cache: number;
    cantidad: number;
    capacidad: number;
    categoria_tamaño: string;
    dimension: number;
    fecha_update: string;
    formato_notebook: number;
    id_producto: number;
    marca: string;
    rpm: number;
    tasa_transf: number;
    tipo: string;
    tipo_almacenamiento: string;
    velocidad_escritura_random: number;
    velocidad_escritura_secuencial: number;
    velocidad_lectura_random: number;
    velocidad_lectura_secuencial: number;
    vida_util: number;
    w: number;
    interfaz?: string;
  };
  public constructor(product: Product) {
    super(product);
    if (product.id_subcategoria !== 81 && product.id_subcategoria !== 19) {
      throw 'esto no es un disco';
    }
  }
}
